import type { SpectralWorkspaceSession } from '../types';

export const WORKSPACE_HRDATA_RAW_EXPORT = {
  id: 'hrdata-raw',
  label: 'hrData grezzi (non riparati)',
  section: 'hrdata-grezzi',
} as const;

/** Sessions for trend export using original hrData only (never repaired). */
export const buildSessionsForRawHrDataTrend = (
  sessions: SpectralWorkspaceSession[]
): SpectralWorkspaceSession[] =>
  sessions
    .map(session => ({
      ...session,
      events: session.rawEvents ?? [],
    }))
    .filter(session => (session.events?.length ?? 0) > 0);

export const hasHrDataRawExportData = (
  sessions: SpectralWorkspaceSession[]
) => sessions.some(session => (session.rawEvents?.length ?? 0) > 0);
